import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mfg-medicare-modal',
  templateUrl: './medicare-modal.component.html',
  styleUrls: ['./medicare-modal.component.css']
})
export class MedicareModalComponent {

  constructor(public activeModal: NgbActiveModal) {}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/medicare-modal/medicare-modal.component.ts